import React from 'react'
import PropTypes from 'prop-types'
import MediaUtilityService from 'shared/services/MediaUtilityService'
import {
  VIDEO_BACKGROUND_PLACEHOLDER, ACCEPTED_VIDEO_FORMATS_REGEX
} from 'shared/constants'
import { Loader } from 'shared/UI/Loader'
import { RingLoader } from 'shared/UI/RingLoader'
import { file_placeholder } from 'common/images/remote/urls.json'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import { triggerClickOnEnter, ACCESSIBILITY_CLASSES } from 'shared/helpers/AccessibilityHelper'

import './style.css.scss'

export const IMAGE_FIT = {
  default: "cover",
  cover: "cover",
  contain: "contain",
  contained: "contain"
}

export const LOADER_TYPE = {
  classic: "classic",
  ring: "ring"
}

export const isItemImagePlaceholder =  (imageUrl) => {
  return imageUrl == file_placeholder
}


const SmartImage = ({ config, alt, isLoading, showLoader, showText, height, width, isImgTag, onClick, className, tabIndex, lazy, loaderType }) => {

  if (isEmpty(get(config, 'url'))) {
    return null
  }

  const isVideo = new RegExp(ACCEPTED_VIDEO_FORMATS_REGEX).test(config.url)

  const getLoader = () => {
    return loaderType == LOADER_TYPE.classic ? <Loader /> : <RingLoader />
  }

  if (isLoading) {
    return (
      <div className="smart-image item-image-column loading ">
        <span className="icon-picture" />
        { showText &&
          <div className='info'>
            <div className='primary-info'>Generating first page thumbnail</div>
            <div className='secondary-info'>This may take a few minutes..</div>
          </div>
        }
        {
          showLoader && !showText && getLoader()
        }
      </div>
    )
  }
  else {
    // This doesn't use the cloudinary react API because the API waits for all
    // images to load before it renders them, which fries the CPU in Content Center.
    // This was fixed in release 1.1.1 of the API but it requires react 16.
    const url = config.optimized_url || MediaUtilityService.getImageUrl({
      image: {...config, url: isVideo ? VIDEO_BACKGROUND_PLACEHOLDER : config.url },
      height,
      width
    })

    const backgroundSize = IMAGE_FIT[config.fit] || IMAGE_FIT.default

    if (isImgTag) {
      return (
        <img
          src={url}
          alt={alt}
          loading={lazy ? "lazy" : "eager"}
          className={`smart-image ${className} ${ACCESSIBILITY_CLASSES.main} ${backgroundSize}`}
          onClick={onClick}
          onKeyDown={triggerClickOnEnter}
          role="button"
          tabIndex={onClick && (tabIndex || 0)} />
      )
    }

    return (
      <div
        style={{backgroundImage: `url(${url})`, backgroundSize: backgroundSize }}
        className={`smart-image ${className} ${ACCESSIBILITY_CLASSES.main}`}
        onClick={onClick}
        onKeyDown={triggerClickOnEnter}
        role="button"
        aria-label={alt}
        tabIndex={onClick && (tabIndex || 0)} />
    )
  }
}

SmartImage.propTypes = {
  config: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  showLoader: PropTypes.bool,
  showText: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isImgTag: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  loaderType: PropTypes.string
}

SmartImage.defaultProps = {
  config: {},
  showText: false,
  showLoader: true,
  className: '',
  loaderType: LOADER_TYPE.classic,
  isImgTag: true,
  lazy: true
}

export default SmartImage
